const ValidationTreeActions = {
    TOGGLE_FILTER: "validation-tree/toggle-filter",
};

export default ValidationTreeActions;



// WEBPACK FOOTER //
// ./app/data/ValidationTreeActions.js